/**
 * Form/action shape for the Topal connect step.
 *
 * The customer supplies four fields in the connect modal; the service maps them into
 * the generic create envelope (`POST /api/integrations/topal` with
 * `{ displayName, vendorInput: { serverUrl, username, password } }`). The BE's
 * `TopalAuthAdapter` then mints a Bearer token via the password grant and runs a smoke
 * test (`GET /clients`) atomically before persisting the connection.
 *
 * Security note: `password` flows through the NgRx action stream and HTTP call. It is
 * encrypted at rest on the BE side via a per-connection DEK. Do NOT log this object or
 * echo it back to the user.
 */
export interface ITopalConnectBody {
    /** UI label for the connection, surfaced in the manage modal server list. */
    displayName: string;
    /** Customer's on-prem Topal base URL incl. port, no trailing path. e.g. `https://topal.example.ch:9001`. */
    serverUrl: string;
    /** Topal login username (e.g. the API service user). Not secret. */
    username: string;
    /** Topal login password. Sensitive. */
    password: string;
}
